import { useRef } from "react";

interface Props {
	title: string;
	image: string;
	onImageChange: (base64Image: string) => void;
	wrapperOption?: {
		wrapperStyle: string;
	};
}

export const ImageForm = (props: Props) => {

	const { 
		title,
		image,
		onImageChange,
		wrapperOption = {
			wrapperStyle: "w-[120px] h-[120px]",
		}
	} = props;
	const fileInputRef = useRef<HTMLInputElement>(null);

	const handleSelect = () => {
		fileInputRef.current?.click();
	};

	const handleDelete = () => {
		onImageChange(""); // 이미지 제거
	};

	const handleFileChange = (e: React.ChangeEvent<HTMLInputElement>) => {
		const file = e.target.files?.[0];
		if (!file) return;

		const reader = new FileReader();
		reader.onloadend = () => {
			const result = reader.result as string;
			const base64 = result.replace(/^data:image\/[a-z]+;base64,/, "");
			onImageChange(base64); // base64만 전달
		};
		reader.readAsDataURL(file);
	};


	return <div className={`
								${wrapperOption.wrapperStyle}
								border border-gray-300 flex flex-col items-center`
							}>
		<div className="w-full h-[24px] border-b border-gray-300 flex justify-center items-center">
			<p tabIndex={0}>
				{title}
			</p>
		</div>
		<div className="w-full flex-1 overflow-hidden flex items-center justify-center">
			{image && <img className="max-w-full max-h-full object-contain" src={`data:image/png;base64,${image}`} />}
		</div>
		<div className="w-full h-[24px] flex justify-center items-center gap-[6px] border-t border-gray-300">
				<button
					className="text-white h-[80%] rounded-[4px] bg-blue-dark px-[8px] text-[12px] font-semibold flex items-center"
					onClick={handleSelect}
				>
					선택
				</button>
				<button
					className="text-white h-[80%] rounded-[4px] bg-red-light px-[8px] text-[12px] font-semibold flex items-center"
					onClick={handleDelete}
				>
					삭제
				</button>
			</div>
		<input
			type="file"
			accept="image/*"
			ref={fileInputRef}
			style={{ display: "none" }}
			onChange={handleFileChange}
		/>
	</div>
}